// filter-condition-input.component.ts
import { Component, EventEmitter, Input, OnInit, Output, OnChanges, SimpleChanges } from '@angular/core';
import { ActivityField, FieldDocument, FieldOption, FieldType, UserDocument } from 'server-model';

@Component({
  selector: 'app-filter-condition-input',
  templateUrl: './filter-condition-input.component.html',
  styleUrl: './filter-condition-input.component.scss'
})
export class FilterConditionInputComponent implements OnInit, OnChanges {
  @Input() selectedField: string = '';
  @Input() selectedFieldType: FieldType | null = null;
  @Input() value: string = '';
  @Input() fieldDocuments: FieldDocument[] | ActivityField[] = [];
  @Input() allUsers: UserDocument[] = [];

  @Output() onUpdateValue = new EventEmitter<any>();
  @Output() onInvalidationChange = new EventEmitter<boolean>();

  fieldTypes = FieldType;
  options: FieldOption[] = [];

  ngOnInit() {
    this.updateOptions();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['selectedField'] || changes['fieldDocuments']) {
      this.updateOptions();
    }
  }

  private updateOptions() {
    this.options = this.fieldDocuments.find(field => field.name === this.selectedField)?.option ?? [];
  }

  updateValue(value: any) {
    this.onUpdateValue.emit(value);
  }

  // Handle invalidation from child components
  onInvalidateField(state: boolean) {
    this.onInvalidationChange.emit(state);
  }
}